module.exports = __webpack_public_path__ + "static/media/logo.2ab60b08.svg";